import { isSearchReport } from 'reporting-data/report/configReportGetters';
import { isConfigReport, isRelationalReport, isUnifiedAnalyticsReport, isUnifiedEventsReport } from 'reporting-data/tsTypes/reportTypes';
import { REPORT_OPTIONS_CRB_BASED_GATE } from '../../constants/gates';
export const getIsReportValidForMetricsEditorDropdown = ({
  report,
  userInfo
}) => {
  if (isConfigReport(report)) {
    if (isSearchReport(report)) {
      return false;
    }
    return !isUnifiedAnalyticsReport(report) && !isUnifiedEventsReport(report);
  } else if (isRelationalReport(report)) {
    return !!(userInfo !== null && userInfo !== void 0 && userInfo.gates.includes(REPORT_OPTIONS_CRB_BASED_GATE));
  }
  return false;
};